import React from 'react'

const Frontend = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Frontend Developer</h3>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check'></i>
                <div className="">
                    <h3 className="skills__name">Flutter</h3>
                    <span className="skills__level">advanced</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check'></i>
                <div className="">
                    <h3 className="skills__name">React</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check'></i>
                <div className="">
                    <h3 className="skills__name">Html</h3>
                    <span className="skills__level">basic</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check'></i>
                <div className="">
                    <h3 className="skills__name">CSS</h3>
                    <span className="skills__level">advanced</span>
                </div>
                </div>
            </div>
            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check'></i>
                <div className="">
                    <h3 className="skills__name">Javascript</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check'></i>
                <div className="">
                    <h3 className="skills__name">Tailwind</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check'></i>
                <div className="">
                    <h3 className="skills__name">Git</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Frontend